import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="UploadInfoBar">
            <div class="UploadInfoBar__inner">
                <div class="UploadInfoBar__info">
                    <b>{{ label }}</b>

                    <ul class="UploadInfoBar__list">
                        <li v-for="doc in options.documents">{{ doc.name }} <span>{{ Math.round(doc.size / 1024) }} KB</span></li>
                    </ul>
                </div>

                <div class="UploadInfoBar__controls">
                    <button type="button" class="desktop button button--secondary" @click="$emit('change')">Wgraj inną fakturę</button>

                    <button type="button" class="mobile button" @click="$emit('change')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path d="M9.06 11.7C9.32667 11.7 9.59333 11.5934 9.79333 11.3934L15.2467 5.94002V22.3533C15.2467 22.9267 15.7133 23.38 16.2733 23.38C16.8333 23.38 17.3 22.9133 17.3 22.3533V5.95335L22.7533 11.4067C23.1533 11.8067 23.8067 11.8067 24.22 11.4067C24.62 11.0067 24.62 10.3534 24.22 9.94002L17.0067 2.72668C17.0067 2.72668 16.9 2.63335 16.8467 2.59335C16.8333 2.59335 16.82 2.58002 16.7933 2.56668C16.7533 2.54002 16.7133 2.51335 16.66 2.50002C16.6333 2.50002 16.62 2.50002 16.5933 2.47335C16.5533 2.46002 16.5133 2.44668 16.46 2.43335C16.4333 2.43335 16.4067 2.43335 16.3667 2.43335C16.3267 2.43335 16.2867 2.43335 16.26 2.43335C16.2333 2.43335 16.18 2.43335 16.1533 2.43335C16.1267 2.43335 16.1 2.43335 16.06 2.43335C16.02 2.43335 15.98 2.46002 15.9267 2.47335C15.9 2.47335 15.8867 2.47335 15.86 2.48668C15.82 2.50002 15.7667 2.52668 15.7267 2.55335C15.7133 2.55335 15.6867 2.56668 15.6733 2.58002C15.62 2.62002 15.5667 2.66002 15.5133 2.71335L8.3 9.92668C7.9 10.3267 7.9 10.98 8.3 11.3934C8.5 11.5934 8.76667 11.7 9.03333 11.7H9.06Z" fill="#005537"/>
                            <path d="M29.5337 15.8467C28.9603 15.8467 28.507 16.3133 28.507 16.8733C28.507 23.4333 23.1737 28.7667 16.6137 28.7667C10.0537 28.7667 4.72033 23.4333 4.72033 16.8733C4.72033 16.3 4.25366 15.8467 3.69366 15.8467C3.13366 15.8467 2.66699 16.3133 2.66699 16.8733C2.66699 24.5667 8.93366 30.8333 16.627 30.8333C24.3203 30.8333 30.587 24.5667 30.587 16.8733C30.587 16.3 30.1203 15.8467 29.5603 15.8467H29.5337Z" fill="#005537"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    `,

    emits: [
        'change',
    ],

    props: {
        options: { type: Object, required: true },

        label: { type: String, default: 'Dane na podstawie:' },
    },
});
